import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router';

import { Spinner } from '@/components/ui/spinner';
import { PageWrapper } from '@/sections/signup/PageWrapper';
import { SignupError } from '@/sections/signup/SignupError';
import { useDomainSsoSignIn } from '@/sections/signup/useDomainSsoSignIn';

export const SSOAutoRedirect = () => {
  const { domain } = useParams();
  const [searchParams] = useSearchParams();
  const domainSsoSignIn = useDomainSsoSignIn();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    domainSsoSignIn(domain!, searchParams.get('redirect')).then(result => {
      if (result === 'not-configured') {
        setError(`SSO is not configured for ${domain}.`);
      } else if (result === 'error') {
        setError(`Unable to verify SSO configuration for ${domain}.`);
      }
    });
  }, [domain, searchParams, domainSsoSignIn]);

  if (!error) {
    return <Spinner centered size="xl" />;
  }

  return (
    <PageWrapper title="Sign in with SSO" showBack={true}>
      <div className="flex flex-1 flex-col gap-4 p-2">
        <SignupError error={error} />
      </div>
    </PageWrapper>
  );
};
